import * as React from 'react';

import { sections } from 'components/lexemes';

import {
  SectionOneContainer,
  SectionTwoContainer,
  SectionThreeContainer,
  SectionFourContainer,
  SectionFiveContainer,
  SectionSixContainer,
  SectionSevenContainer,
  SectionEightContainer,
  SectionNineContainer,
} from 'containers/sections';

import { TabIdList } from 'components/tab-list';

const mapSectionContentToTabIdList: { [key in TabIdList]: React.FC } = {
  [TabIdList.DataCollection]: SectionOneContainer,
  [TabIdList.InformationUsage]: SectionTwoContainer,
  [TabIdList.InformationDisclosure]: SectionThreeContainer,
  [TabIdList.InformationSharing]: SectionFourContainer,
  [TabIdList.Rights]: SectionFiveContainer,
  [TabIdList.InformationStoring]: SectionSixContainer,
  [TabIdList.SecurityAndAge]: SectionSevenContainer,
  [TabIdList.ContactUs]: SectionEightContainer,
  [TabIdList.UsResidents]: SectionNineContainer,
};

export const getPropsLandingBlockThreeContainer = () => {
  return {
    sections: [
      {
        id: TabIdList.DataCollection,
        label: sections.tabsMenuSection.lxPagePrivacyPolicyTabsMenuSectionListItemOne(),
        content: mapSectionContentToTabIdList[TabIdList.DataCollection]({}),
      },
      {
        id: TabIdList.InformationUsage,
        label: sections.tabsMenuSection.lxPagePrivacyPolicyTabsMenuSectionListItemTwo(),
        content: mapSectionContentToTabIdList[TabIdList.InformationUsage]({}),
      },
      {
        id: TabIdList.InformationDisclosure,
        label: sections.tabsMenuSection.lxPagePrivacyPolicyTabsMenuSectionListItemThree(),
        content: mapSectionContentToTabIdList[TabIdList.InformationDisclosure]({}),
      },
      {
        id: TabIdList.InformationSharing,
        label: sections.tabsMenuSection.lxPagePrivacyPolicyTabsMenuSectionListItemFour(),
        content: mapSectionContentToTabIdList[TabIdList.InformationSharing]({}),
      },
      {
        id: TabIdList.Rights,
        label: sections.tabsMenuSection.lxPagePrivacyPolicyTabsMenuSectionListItemFive(),
        content: mapSectionContentToTabIdList[TabIdList.Rights]({}),
      },
      {
        id: TabIdList.InformationStoring,
        label: sections.tabsMenuSection.lxPagePrivacyPolicyTabsMenuSectionListItemSix(),
        content: mapSectionContentToTabIdList[TabIdList.InformationStoring]({}),
      },
      {
        id: TabIdList.SecurityAndAge,
        label: sections.tabsMenuSection.lxPagePrivacyPolicyTabsMenuSectionListItemSeven(),
        content: mapSectionContentToTabIdList[TabIdList.SecurityAndAge]({}),
      },
      {
        id: TabIdList.ContactUs,
        content: mapSectionContentToTabIdList[TabIdList.ContactUs]({}),
      },
      {
        id: TabIdList.UsResidents,
        label: sections.tabsMenuSection.lxPagePrivacyPolicyTabsMenuSectionListItemEight(),
        content: mapSectionContentToTabIdList[TabIdList.UsResidents]({}),
      },
    ],
  };
};
